import { render } from "./SendInvoices.vue?vue&type=template&id=e6664260&scoped=true&ts=true"
import script from "./SendInvoices.vue?vue&type=script&lang=ts"
export * from "./SendInvoices.vue?vue&type=script&lang=ts"

import "./SendInvoices.vue?vue&type=style&index=0&id=e6664260&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6664260"]])

export default __exports__